import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import BasicData from './BasicData';
import { useForm } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { Alert, Grid } from '@mui/material';
import { TicketCloseFormModel } from '../../models/ticket.model';
import { GREEN_BKG_FORM, GREEN_DARK, MARGIN_PAPER_FORM } from '../../assets/Styles';
import { getClosingCauses } from '../../services/autocomplete.service';
import { useNotification } from '../../context/NotificationContext';


const CustomPaper = styled(Paper)(({ theme }) => ({
  borderColor: GREEN_DARK,
  marginBottom: MARGIN_PAPER_FORM,
  padding: theme.spacing(2),
  ...theme.typography.body2,
}));

interface HandleFormProps {
  action: string
  handleChange: (p: any) => void
  handleSelection: (key: string, value: string) => void
  onSubmit: (p: any) => void
  ticketCloseForm: any
  selectedProject: string
}

export default function HandleForm({action, handleChange, handleSelection, onSubmit,
  ticketCloseForm, selectedProject}: HandleFormProps) {

  const { showNotification } = useNotification();
  const { handleSubmit } = useForm<TicketCloseFormModel>()

  const [closingCausesList, setClosingCausesList] = useState([]);

  const requiredFields = [
    'closing_cause',
  ]

  const initComponent = () => {
    if (action === "create") {
      Promise.all([
        getClosingCauses(selectedProject),
      ]).then(function (result) {
        setClosingCausesList(result[0])
      }).catch((error) => {
        showNotification(error.response.data)
      });
    }
  };

  useEffect(initComponent, [])

  const formValidator = () => {
    return requiredFields.some((key) => !ticketCloseForm[key] || Object.keys(ticketCloseForm[key]).length === 0)
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Box>
        <Paper
          sx={{
            my: { xs: 5, md: 6 }, p: { xs: 1, md: 2 }, mx: { xs: 0, md: 4 },
            backgroundColor: GREEN_BKG_FORM,
          }}>

          <React.Fragment>

            <CustomPaper variant="outlined">
              <BasicData action={action}
                handleChange={handleChange}
                handleSelection={handleSelection}
                closingCausesList={closingCausesList}
                ticketCloseForm={ticketCloseForm}
              />
            </CustomPaper>

            <Grid container marginTop={'4vh'} rowSpacing={'2vh'} columnSpacing={'2vw'}>
              <Grid item xs={12} md={4}>
                <Typography fontFamily="Poppins" variant="body2" gutterBottom>
                  (*) Campos requeridos
                </Typography>
              </Grid>

              <Grid item xs={12} md={4}>
                <Alert
                  sx={{ display: formValidator() ? 'flex' : 'none' }}
                  color="error"
                  severity="info">
                  Hay campos requeridos sin completar
                </Alert>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    style={{ display: action === 'view' ? 'none' : '' }}
                    sx={{ fontFamily: 'Poppins' }}
                    variant="contained"
                    color="success"
                    onClick={handleSubmit(onSubmit)}
                    disabled={formValidator()}
                  >
                    Confirmar
                  </Button>
                </Box>
              </Grid>

            </Grid>

          </React.Fragment>
        </Paper>
      </Box>
    </React.Fragment>
  );
}
